module.exports = __webpack_public_path__ + "static/media/Imagen_Login_basic.5c4cc4dd.png";